import React, {useContext} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {Input as ReactstrapInput} from 'reactstrap';
import {InputProps} from './Input';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import trans from '@src/helpers/trans';
import TriggerableField from '../utils/TriggerableField';

export default function ControlledInput<Model extends IEmptyModel>(props: {
    onChange: (value: any, next: (value: any) => void) => void
} & InputProps<Model>) {
    const {control} = useFormContext<Model>();
    const [design] = useContext(FormFieldDesignContext);

    const name = props.fieldName as any;

    return <Controller
            name={name}
            control={control}
            render={({field: {ref, name, onChange, onBlur}, fieldState: {error}}) => {
                const isInvalid = props.isInvalid ?? Boolean(error);

                return <TriggerableField
                        trigger={props.config.trigger}
                        componentToRender={ReactstrapInput}
                        innerRef={ref}
                        name={name}
                        onChange={(...args) => props.onChange(...args, onChange)}
                        onBlur={onBlur}
                        {...(props.config.attributes ?? {})}
                        className={classnames({
                            'is-invalid': isInvalid,
                        }, props.config.cssClass, props.className)}
                        invalid={isInvalid}
                        bsSize={props.config.size || design.size}
                        placeholder={trans('Forms.enter_field', {field: props.label.toLowerCase()})}
                        readOnly={props.config.readOnly === true || design.fieldsAreReadOnly || props.forceReadonly}
                        disabled={props.config.disabled === true || design.fieldsAreDisabled || props.forceDisabled}
                        type={props.type}
                        id={props.id}
                        multiple={props.multiple}
                        accept={props.accept}
                        maxLength={props.maxLength}
                />;
            }}
    />;
}
